var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGoldenStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.889231
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8871 8.91142C35.0228 8.185 35.4083 7.5289 35.9767 7.05676C36.5452 6.58462 37.2609 6.32617 37.9999 6.32617C38.7389 6.32617 39.4546 6.58462 40.0231 7.05676C40.5916 7.5289 40.9771 8.185 41.1128 8.91142L44.4409 26.5118C44.6773 27.7631 45.2854 28.914 46.1859 29.8145C47.0863 30.7149 48.2373 31.323 49.4886 31.5594L67.0889 34.8876C67.8154 35.0233 68.4714 35.4087 68.9436 35.9772C69.4157 36.5457 69.6742 37.2614 69.6742 38.0004C69.6742 38.7394 69.4157 39.4551 68.9436 40.0236C68.4714 40.5921 67.8154 40.9776 67.0889 41.1133L49.4886 44.4414C48.2373 44.6778 47.0863 45.2859 46.1859 46.1863C45.2854 47.0868 44.6773 48.2378 44.4409 49.4891L41.1128 67.0894C40.9771 67.8158 40.5916 68.4719 40.0231 68.9441C39.4546 69.4162 38.7389 69.6747 37.9999 69.6747C37.2609 69.6747 36.5452 69.4162 35.9767 68.9441C35.4083 68.4719 35.0228 67.8158 34.8871 67.0894L31.5589 49.4891C31.3226 48.2378 30.7145 47.0868 29.814 46.1863C28.9136 45.2859 27.7626 44.6778 26.5113 44.4414L8.91093 41.1133C8.18451 40.9776 7.52841 40.5921 7.05627 40.0236C6.58413 39.4551 6.32568 38.7394 6.32568 38.0004C6.32568 37.2614 6.58413 36.5457 7.05627 35.9772C7.52841 35.4087 8.18451 35.0233 8.91093 34.8876L26.5113 31.5594C27.7626 31.323 28.9136 30.7149 29.814 29.8145C30.7145 28.914 31.3226 27.7631 31.5589 26.5118L34.8871 8.91142Z",
    stroke: "#FDC700",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3335 6.33301V18.9997",
    stroke: "#FDC700",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6667 12.667H57",
    stroke: "#FDC700",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 69.6667C16.1646 69.6667 19.0002 66.8311 19.0002 63.3333C19.0002 59.8355 16.1646 57 12.6668 57C9.16903 57 6.3335 59.8355 6.3335 63.3333C6.3335 66.8311 9.16903 69.6667 12.6668 69.6667Z",
    stroke: "#FDC700",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoldenStar);
export default __webpack_public_path__ + "static/media/ic_golden_star.d7de2167eb3e36a10d0897b826e0f3c5.svg";
export { ForwardRef as ReactComponent };